import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M4.22222 3H19.7778C20.4556 3 21 3.54902 21 4.22222V19.7778C21 20.451 20.4556 21 19.7778 21H4.22222C3.54443 21 3 20.451 3 19.7778V4.22222C3 3.54903 3.54443 3 4.22222 3Z"
      stroke="black"
      strokeOpacity={0.4}
      strokeWidth={2}
    />
  </Svg>
);
export default SVGComponent;
